import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { api_url, environment } from "../config.js";

const fake_token =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOi9hay5leGFtcGxlLmNvbS9hdXRoL3JlYWxttV7Y3cskztDZqqmQI";

export const getOSs = createAsyncThunk(
  "OS/getOSs",
  async (_, { getState, rejectWithValue }) => {
    const keycloak = JSON.parse(localStorage.getItem("keycloak") || "{}");
    const token =
      environment === "production-no-auth" ? fake_token : keycloak?.token;

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get(`${api_url}/Os`, config);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail || "Error: Listing all OSs failed.",
      );
    }
  },
);

export const getOSDetails = createAsyncThunk(
  "OS/details",
  async (id, { getState, rejectWithValue }) => {
    const keycloak = JSON.parse(localStorage.getItem("keycloak") || "{}");

    const token =
      environment === "production-no-auth" ? fake_token : keycloak?.token;

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get(`${api_url}/Os/${id}`, config);
      return data;
    } catch (error) {
      if (environment === "development") {
        console.error("Error :", error.message);
      }
      return rejectWithValue(
        error.response?.data?.detail || "Error: Fetching OS details failed.",
      );
    }
  },
);
